import { CurrencySettings, currencySetting, type CurrencySetting } from "@looksrare/config";

export const getCurrencyDisplayDecimals = (
  currencySymbol: keyof CurrencySettings,
  size: keyof CurrencySetting["displayDecimals"] = "default"
) => {
  const { displayDecimals } = currencySetting[currencySymbol];
  return displayDecimals[size] || displayDecimals.default;
};
